module.exports = {
	"_format": "hh-sol-artifact-1",
	"contractName": "Ethernaut",
	"sourceName": "contracts/Ethernaut.sol",
	"abi": [
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "player",
					"type": "address"
				},
				{
					"indexed": false,
					"internalType": "contract Level",
					"name": "level",
					"type": "address"
				},
				{
					"indexed": false,
					"internalType": "string",
					"name": "nickname",
					"type": "string"
				}
			],
			"name": "LevelCompletedLog",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "player",
					"type": "address"
				},
				{
					"indexed": false,
					"internalType": "address",
					"name": "instance",
					"type": "address"
				},
				{
					"indexed": false,
					"internalType": "string",
					"name": "nickname",
					"type": "string"
				}
			],
			"name": "LevelInstanceCreatedLog",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"internalType": "address",
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"inputs": [
				{
					"internalType": "contract Level",
					"name": "_level",
					"type": "address"
				}
			],
			"name": "createLevelInstance",
			"outputs": [],
			"stateMutability": "payable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"internalType": "address",
					"name": "",
					"type": "address"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "string",
					"name": "_nickname",
					"type": "string"
				}
			],
			"name": "register",
			"outputs": [
				{
					"internalType": "bool",
					"name": "",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "contract Level",
					"name": "_level",
					"type": "address"
				}
			],
			"name": "registerLevel",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "renounceOwnership",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address payable",
					"name": "_instance",
					"type": "address"
				}
			],
			"name": "submitLevelInstance",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"linkReferences": {},
	"deployedLinkReferences": {}
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/Ethernaut.sol/Ethernaut.json
// module id = 1517
// module chunks = 0